import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Box,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";
import { ButtonLoader, IntroText, Sheet, SheetContent } from "../../components";
import { useHeader } from "../../contexts";
import { formatAmount } from "../../utils";
import { useTranslation } from "react-i18next";

const LineItems = ({ items = [], total }) => {
  const { t } = useTranslation();

  if (items.length < 1) return null;

  return (
    <Table size="small">
      <TableBody>
        {items.map((item, index) => (
          <TableRow key={`line-item-${index}`}>
            <TableCell component="th" scope="row">
              {item.title}
            </TableCell>
            <TableCell align="right">{formatAmount(item.cost)}</TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell component="th" scope="row">
            <strong>{t("common.total")}</strong>
          </TableCell>
          <TableCell align="right">
            <strong>{formatAmount(total)}</strong>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

const AppointmentPayDisclaimer = () => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const location = useLocation();
  const history = useHistory();

  /**
   * Redirect if we don't have the required state
   */
  useEffect(() => {
    const { state } = location;
    if (!state.paymentUrl || !state.totalCost || !state.totalBalance)
      return history.push(`/`);
  }, [location]);

  useEffect(() => {
    setTitle(t("appointment.pay_disclaimer.title"));
  }, []);

  const handlePayment = () => {
    window.location = location.state.paymentUrl;
  };

  return (
    <Sheet data-cy="appointment-pay-disclaimer">
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <IntroText>
                {t("appointment.pay_disclaimer.intro_text")}{" "}
                <strong>{formatAmount(location.state.totalBalance)}</strong>.
              </IntroText>
              {location.state.lineItems && location.state.lineItems.length > 0 && (
                <Box mb={2}>
                  <LineItems
                    items={location.state.lineItems}
                    total={location.state.totalBalance}
                  />
                </Box>
              )}
              <ButtonLoader
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                data-cy="pay-disclaimer-continue"
                onClick={e => handlePayment()}
              >
                {t("common.continue")}
              </ButtonLoader>
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { AppointmentPayDisclaimer };
